import { APP_URL, AUTH_URL } from 'config/auth';

export const redirectToAuth = () => {
    window.location.href = `${AUTH_URL}/auth/login?callbackUrl=${APP_URL}${
        window.location.pathname + window.location.search
    }`;
};
